import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from '@angular/core';
import { LoadListener } from '@veone/ngx-utilities/rxjs';
import { Observable, forkJoin, map } from 'rxjs';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { MEDIA_TYPES } from '~app/app/~shared/constants/global.constants';
import { SubscriberMetricsService } from '~app/app/~shared/services/subscriber-metrics.service';
import { MediaType } from '~core/models/core.models';
import { ProfitableChannelStat } from '~core/models/metrics.models';

@Component({
  selector: 'mediatype-stat-cards',
  templateUrl: './mediatype-stat-cards.component.html',
  styleUrl: './mediatype-stat-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediatypeStatCardsComponent
  extends BaseComponent
  implements OnInit
{
  private _subscriberMetricsService = inject(SubscriberMetricsService);

  profitableChannelsListener:
    | LoadListener<{ [key in MediaType]?: ProfitableChannelStat[] }>
    | undefined;

  mediaTypesKeys: MediaType[] = Object.keys(MEDIA_TYPES) as MediaType[];

  mediaTypes = MEDIA_TYPES;

  ngOnInit(): void {
    this.initMediaTypeStatsListener();
  }

  initMediaTypeStatsListener(): void {
    const observables: Observable<{
      [key in MediaType]?: ProfitableChannelStat[];
    }> = forkJoin(
      this.mediaTypesKeys.map(mediaType =>
        this._subscriberMetricsService
          .getProfitableChannels({ mediaType })
          .pipe(
            map((data: ProfitableChannelStat[]) => ({
              [mediaType]: data
            }))
          )
      )
    ).pipe(
      map(results => {
        return results.reduce((acc, curr) => ({ ...acc, ...curr }), {});
      })
    );

    this.profitableChannelsListener = new LoadListener(observables);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isStateEmpty(state?: any): boolean {
    return state ? Object.keys(state).length === 0 : false;
  }
}
